'use client'

import { VisibleOn } from '@/components/v3/atoms/visible-on'
import { useClampToggle } from '@/hooks/use-clamp-toggle'
import s from './supplier-description.module.scss'
import { ClampButton } from '@/components/v3/atoms/clamp-button/clamp-button'
import cx from 'classnames'

type Props = {
  description: string
}

export const SupplierDescriptionV3 = ({ description }: Props) => {
  const { ref: descRef, isClamped, isOpen, toggle } = useClampToggle()
  const buttonText = isOpen ? 'SHOW LESS' : 'SHOW MORE'

  return (
    <div className={s.container}>
      <p
        ref={descRef}
        className={cx(s.description, {
          [s.descriptionOpen]: isOpen,
        })}
      >
        {description}
      </p>
      {isClamped && (
        <VisibleOn mobile className={s.buttonContainer}>
          <ClampButton
            isOpen={isOpen}
            onClick={toggle}
            fill={'#000000'}
            text={buttonText}
          />
        </VisibleOn>
      )}
    </div>
  )
}
